module.exports = __webpack_public_path__ + "static/img/zip-bg.774c172.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/blockIcon/zip-bg.png
// module id = XneD
// module chunks = 96